import { Auth } from "aws-amplify";

import { useAsyncCall } from "hooks";

export function useAuthenticationManager() {
  const [call, isProcessing] = useAsyncCall();

  return {
    isProcessing: isProcessing,
    signIn: (email, password) => {
      return call(() => {
        return Auth.signIn(email, password);
      });
    },
    confirmSignUp: (email, code) => {
      return call(() => {
        return Auth.confirmSignUp(email, code);
      });
    },
    resendSignUp: (email) => {
      return call(() => {
        return Auth.resendSignUp(email);
      });
    },
    signUp: (email, password) => {
      return call(() => {
        return Auth.signUp({
          username: email,
          password: password,
          autoSignIn: { enabled: true },
          attributes: { "custom:signUpVersion": "v2" },
        });
      });
    },
    forgotPassword: (email) => {
      return call(() => {
        return Auth.forgotPassword(email);
      });
    },
    forgotPasswordSubmit: (email, code, password) => {
      return call(() => {
        return Auth.forgotPasswordSubmit(email, code, password);
      });
    },
  };
}

export default useAuthenticationManager;
